export const PRICE_ELASTICITY_MODEL = "price_elasticity_model"
export const PRICE_ELASTICITY_LOCAL_FILTER = "price_elasticity_local_filter"